import axios from 'axios';

//axios.defaults.baseURL = 'http://167.235.198.244:5000/';
//axios.defaults.baseURL = 'http://0.0.0.0:80/';
axios.defaults.baseURL = 'http://128.140.92.57/';